import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4afd3d18&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4afd3d18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd3d18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4afd3d18')) {
      api.createRecord('4afd3d18', component.options)
    } else {
      api.reload('4afd3d18', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4afd3d18&scoped=true", function () {
      api.rerender('4afd3d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/person/index.vue"
export default component.exports